import { render, staticRenderFns } from "./JewelleryText.vue?vue&type=template&id=1d866350"
import script from "./JewelleryText.vue?vue&type=script&lang=js"
export * from "./JewelleryText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports